import { newToolFilterOAuthMcp } from "../oauth.ts";

export const globalpingMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://globalping.io/icons/apple-touch-icon.png",
  url: "https://mcp.globalping.dev/mcp",
  label: "Globalping",
});
